import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState} from '../store/states/app.state';
import {NGXLogger} from 'ngx-logger';
import {BelegEntitiesSelectors} from '../store/selectors/beleg-entities.selectors';
import {BelegEntitiesActions} from '../store/actions/beleg-entities.actions';
import {combineLatest, filter, take} from 'rxjs';
import {NavigationService} from '@adnova/jf-ng-components';

/**
 * Lädt die Mitarbeiter je Inhaber genau einmal.
 *
 * INFO: Anders als der VorgangsartResolver wird nicht auf "keine Mitarbeiter im State" geprüft, sondern auf
 * `mitarbeiterGeladenInhaberIds`. Inhaber ohne Mitarbeiter sind der Normalfall; eine leere Antwort würde sonst
 * endlos neue Requests auslösen. Die Navigation wird nicht blockiert.
 */
@Injectable()
export class MitarbeiterResolver {
  constructor(
    private store: Store<AppState>,
    private logger: NGXLogger,
    private navigationService: NavigationService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    combineLatest([
      // INFO: Die Inhaber-Liste kann beim ersten Aufruf noch leer sein (z.B. Reload per Deep-Link).
      this.navigationService.inhaberList$.pipe(filter(inhaberDtos => !!inhaberDtos?.length)),
      this.store.select(BelegEntitiesSelectors.mitarbeiterGeladenInhaberIds),
    ])
      .pipe(take(1))
      .subscribe(([inhaberDtos, geladenInhaberIds]) => {
        for (const inhaberDto of inhaberDtos) {
          if (geladenInhaberIds?.includes(inhaberDto.id)) continue;

          this.logger.debug('trigger readMitarbeiter from mitarbeiter-resolver. inhaberId:', inhaberDto.id);
          this.store.dispatch(
            BelegEntitiesActions.readMitarbeiter({
              inhaberId: inhaberDto.id,
            }),
          );
        }
      });

    return true;
  }
}
